import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals.ts';

import '@fontsource/outfit/index.css';
import '@mantine/core/styles.css';
import '@mantine/nprogress/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import 'dayjs/locale/id';
import './styles.css';

import dayjs from 'dayjs';
import { persistQueryClientRestore } from '@tanstack/react-query-persist-client';
import { env } from './consts/env.ts';
import { getQueryClient, Provider } from './providers';
import { persister } from './providers/QueryProvider.tsx';

dayjs.locale('id');

const rootElement = document.getElementById('app');

async function bootstrap() {
  await persistQueryClientRestore({
    queryClient: getQueryClient().queryClient,
    persister: persister,
    buster: 'v1', // optional versioning
  });

  if (rootElement && !rootElement.innerHTML) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <StrictMode>
        <Provider />
      </StrictMode>
    );
  }
}
bootstrap();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
if (!env.web_vitals) {
  reportWebVitals(console.table);
}
